// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Form from "../../bundles/Form/Form.res.js";
import * as Grid from "../../resources/layout-and-structure/Grid.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Icon from "../../resources/images-and-icons/Icon.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Loyalty from "../Loyalty/Loyalty.res.js";
import * as Spinner from "../../resources/feedback-indicators/Spinner.res.js";
import * as NextBadge from "../../resources/feedback-indicators/NextBadge.res.js";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as CanaryCard from "../../resources/layout-and-structure/CanaryCard.res.js";
import * as CountBadge from "../../resources/feedback-indicators/CountBadge.res.js";
import * as NextBanner from "../../resources/feedback-indicators/NextBanner.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as ProgressBar from "../../resources/feedback-indicators/ProgressBar.res.js";
import * as SliderTrack from "../../resources/layout-and-structure/SliderTrack.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as CanarySurface from "../../resources/layout-and-structure/CanarySurface.res.js";
import * as Primitive_int from "@rescript/runtime/lib/es6/Primitive_int.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as StringHelpers from "../../helpers/StringHelpers.res.js";
import * as Client from "@apollo/client";
import * as CustomerRoutes from "../../app/Customer/CustomerRoutes.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Form__Submission from "../../bundles/Form/Form__Submission.res.js";
import * as InputNumberField from "../../resources/selection-and-input/InputNumberField.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CanaryCardInfoSwap from "../../resources/layout-and-structure/CanaryCardInfoSwap.res.js";
import * as InputCheckboxField from "../../resources/selection-and-input/InputCheckboxField.res.js";
import * as Graphql_ppx_runtime from "@reasonml-community/graphql-ppx/rescript-runtime/graphql_ppx_runtime.res.js";
import * as CustomerDetailsLoyaltyHistoryPage from "../../app/Customer/CustomerDetailsLoyaltyHistoryPage.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";
let Raw = {};
let query = Client.gql(["fragment CustomerDetailsLoyaltyVoucherFragment on Voucher   {\n__typename  \nid  \nstatus  \narchivedAt  \nreward  {\n__typename  \nid  \narchivedAt  \nstatus  \nkind  \ndiscountUnit  \ndiscountValue  \ndiscountEvolutiveRate  {\n__typename  \neuros  \npoints  \n}\n\nofferedProductLabel  \nofferedVariant  {\n__typename  \nid  \nformattedName  \n}\n\npointsToUnlock  \nvisitsToUnlock  \nresetsWhenApplied  \n}\n\n}\n"]);
function parse(value) {
  let value$1 = value.status;
  let tmp;
  switch (value$1) {
    case "LOCKED":
      tmp = "LOCKED";
      break;
    case "UNLOCKED":
      tmp = "UNLOCKED";
      break;
    case "USED":
      tmp = "USED";
      break;
    default:
      throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
      };
  }
  let value$2 = value.archivedAt;
  let value$3 = value.reward;
  let tmp$1;
  if (value$3 == null) {
    tmp$1 = undefined;
  } else {
    let value$4 = value$3.archivedAt;
    let value$5 = value$3.status;
    let tmp$2;
    switch (value$5) {
      case "PUBLISHED":
        tmp$2 = "PUBLISHED";
        break;
      case "UNPUBLISHED":
        tmp$2 = "UNPUBLISHED";
        break;
      default:
        throw {
          RE_EXN_ID: "Not_found",
          Error: new Error()
        };
    }
    let value$6 = value$3.kind;
    let tmp$3;
    switch (value$6) {
      case "DISCOUNT":
        tmp$3 = "DISCOUNT";
        break;
      case "OFFERED_PRODUCT":
        tmp$3 = "OFFERED_PRODUCT";
        break;
      default:
        throw {
          RE_EXN_ID: "Not_found",
          Error: new Error()
        };
    }
    let value$7 = value$3.discountUnit;
    let tmp$4;
    if (value$7 == null) {
      tmp$4 = undefined;
    } else {
      let tmp$5;
      switch (value$7) {
        case "EUR":
          tmp$5 = "EUR";
          break;
        case "PERCENTAGE":
          tmp$5 = "PERCENTAGE";
          break;
        default:
          throw {
            RE_EXN_ID: "Not_found",
            Error: new Error()
          };
      }
      tmp$4 = tmp$5;
    }
    let value$8 = value$3.discountValue;
    let value$9 = value$3.discountEvolutiveRate;
    let value$10 = value$3.offeredProductLabel;
    let value$11 = value$3.offeredVariant;
    let value$12 = value$3.pointsToUnlock;
    let value$13 = value$3.visitsToUnlock;
    tmp$1 = {
      __typename: value$3.__typename,
      id: value$3.id,
      archivedAt: !(value$4 == null) ? Scalar.Datetime.parse(value$4) : undefined,
      status: tmp$2,
      kind: tmp$3,
      discountUnit: tmp$4,
      discountValue: !(value$8 == null) ? value$8 : undefined,
      discountEvolutiveRate: !(value$9 == null) ? {
        __typename: value$9.__typename,
        euros: value$9.euros,
        points: value$9.points
      } : undefined,
      offeredProductLabel: !(value$10 == null) ? value$10 : undefined,
      offeredVariant: !(value$11 == null) ? {
        __typename: value$11.__typename,
        id: value$11.id,
        formattedName: value$11.formattedName
      } : undefined,
      pointsToUnlock: !(value$12 == null) ? value$12 : undefined,
      visitsToUnlock: !(value$13 == null) ? value$13 : undefined,
      resetsWhenApplied: value$3.resetsWhenApplied
    };
  }
  return {
    __typename: value.__typename,
    id: value.id,
    status: tmp,
    archivedAt: !(value$2 == null) ? Scalar.Datetime.parse(value$2) : undefined,
    reward: tmp$1
  };
}
function serialize(value) {
  let value$1 = value.reward;
  let reward;
  if (value$1 !== undefined) {
    let value$2 = value$1.resetsWhenApplied;
    let value$3 = value$1.visitsToUnlock;
    let visitsToUnlock = value$3 !== undefined ? value$3 : null;
    let value$4 = value$1.pointsToUnlock;
    let pointsToUnlock = value$4 !== undefined ? value$4 : null;
    let value$5 = value$1.offeredVariant;
    let offeredVariant;
    if (value$5 !== undefined) {
      let value$6 = value$5.formattedName;
      let value$7 = value$5.id;
      let value$8 = value$5.__typename;
      offeredVariant = {
        __typename: value$8,
        id: value$7,
        formattedName: value$6
      };
    } else {
      offeredVariant = null;
    }
    let value$9 = value$1.offeredProductLabel;
    let offeredProductLabel = value$9 !== undefined ? value$9 : null;
    let value$10 = value$1.discountEvolutiveRate;
    let discountEvolutiveRate;
    if (value$10 !== undefined) {
      let value$11 = value$10.points;
      let value$12 = value$10.euros;
      let value$13 = value$10.__typename;
      discountEvolutiveRate = {
        __typename: value$13,
        euros: value$12,
        points: value$11
      };
    } else {
      discountEvolutiveRate = null;
    }
    let value$14 = value$1.discountValue;
    let discountValue = value$14 !== undefined ? value$14 : null;
    let value$15 = value$1.discountUnit;
    let discountUnit = value$15 !== undefined ? value$15 === "EUR" ? "EUR" : "PERCENTAGE" : null;
    let value$16 = value$1.kind;
    let kind = value$16 === "DISCOUNT" ? "DISCOUNT" : "OFFERED_PRODUCT";
    let value$17 = value$1.status;
    let status = value$17 === "UNPUBLISHED" ? "UNPUBLISHED" : "PUBLISHED";
    let value$18 = value$1.archivedAt;
    let archivedAt = value$18 !== undefined ? Scalar.Datetime.serialize(value$18) : null;
    let value$19 = value$1.id;
    let value$20 = value$1.__typename;
    reward = {
      __typename: value$20,
      id: value$19,
      archivedAt: archivedAt,
      status: status,
      kind: kind,
      discountUnit: discountUnit,
      discountValue: discountValue,
      discountEvolutiveRate: discountEvolutiveRate,
      offeredProductLabel: offeredProductLabel,
      offeredVariant: offeredVariant,
      pointsToUnlock: pointsToUnlock,
      visitsToUnlock: visitsToUnlock,
      resetsWhenApplied: value$2
    };
  } else {
    reward = null;
  }
  let value$21 = value.archivedAt;
  let archivedAt$1 = value$21 !== undefined ? Scalar.Datetime.serialize(value$21) : null;
  let value$22 = value.status;
  let status$1 = value$22 === "UNLOCKED" ? "UNLOCKED" : value$22 === "USED" ? "USED" : "LOCKED";
  let value$23 = value.id;
  let value$24 = value.__typename;
  return {
    __typename: value$24,
    id: value$23,
    status: status$1,
    archivedAt: archivedAt$1,
    reward: reward
  };
}
function verifyArgsAndParse(_CustomerDetailsLoyaltyVoucherFragment, value) {
  return parse(value);
}
function verifyName(_fragmentName) {}
let CustomerDetailsLoyaltyVoucherFragment = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};
let Raw$1 = {};
let query$1 = Client.gql(["fragment CustomerDetailsLoyaltyFragment on Customer   {\n__typename  \nhasSubscribedToLoyaltyProgram  \nsubscribedToLoyaltyProgramAt  \nshop  {\n__typename  \nid  \nloyaltyPointsExpirationMonths  \nloyaltyWelcomePoints  \n}\n\nloyalty  {\n__typename  \npoints  \npointsExpiringAt  \npointsExpiring  \n}\n\nunlockedVouchers  {\n...CustomerDetailsLoyaltyVoucherFragment   \n}\n\nlockedVouchers  {\n...CustomerDetailsLoyaltyVoucherFragment   \n}\n\nloyaltyActivities(first: 5)  {\n__typename  \ntotalCount  \nedges  {\n__typename  \nnode  {\n...CustomerDetailsLoyaltyHistoryActivityFragment   \n}\n\n}\n\n}\n\n}\n", "", ""], CustomerDetailsLoyaltyHistoryPage.CustomerDetailsLoyaltyHistoryActivityFragment.query, query);
function parse$1(value) {
  let value$1 = value.subscribedToLoyaltyProgramAt;
  let value$2 = value.shop;
  let value$3 = value$2.loyaltyPointsExpirationMonths;
  let value$4 = value$2.loyaltyWelcomePoints;
  let value$5 = value.loyalty;
  let value$6 = value$5.pointsExpiringAt;
  let value$7 = value$5.pointsExpiring;
  let value$8 = value.unlockedVouchers;
  let value$9 = value.lockedVouchers;
  let value$10 = value.loyaltyActivities;
  let value$11 = value$10.edges;
  return {
    __typename: value.__typename,
    hasSubscribedToLoyaltyProgram: value.hasSubscribedToLoyaltyProgram,
    subscribedToLoyaltyProgramAt: !(value$1 == null) ? Scalar.Datetime.parse(value$1) : undefined,
    shop: {
      __typename: value$2.__typename,
      id: value$2.id,
      loyaltyPointsExpirationMonths: !(value$3 == null) ? value$3 : undefined,
      loyaltyWelcomePoints: !(value$4 == null) ? value$4 : undefined
    },
    loyalty: {
      __typename: value$5.__typename,
      points: value$5.points,
      pointsExpiringAt: !(value$6 == null) ? Scalar.Datetime.parse(value$6) : undefined,
      pointsExpiring: !(value$7 == null) ? value$7 : undefined
    },
    unlockedVouchers: value$8.map(parse),
    lockedVouchers: value$9.map(parse),
    loyaltyActivities: {
      __typename: value$10.__typename,
      totalCount: value$10.totalCount,
      edges: value$11.map(value => {
        let value$1 = value.node;
        return {
          __typename: value.__typename,
          node: CustomerDetailsLoyaltyHistoryPage.CustomerDetailsLoyaltyHistoryActivityFragment.verifyArgsAndParse("CustomerDetailsLoyaltyHistoryActivityFragment", value$1)
        };
      })
    }
  };
}
function serialize$1(value) {
  let value$1 = value.loyaltyActivities;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let node = CustomerDetailsLoyaltyHistoryPage.CustomerDetailsLoyaltyHistoryActivityFragment.serialize(value$1);
    let value$2 = value.__typename;
    return {
      __typename: value$2,
      node: node
    };
  });
  let value$3 = value$1.totalCount;
  let value$4 = value$1.__typename;
  let loyaltyActivities = {
    __typename: value$4,
    totalCount: value$3,
    edges: edges
  };
  let value$5 = value.lockedVouchers;
  let lockedVouchers = value$5.map(serialize);
  let value$6 = value.unlockedVouchers;
  let unlockedVouchers = value$6.map(serialize);
  let value$7 = value.loyalty;
  let value$8 = value$7.pointsExpiring;
  let pointsExpiring = value$8 !== undefined ? value$8 : null;
  let value$9 = value$7.pointsExpiringAt;
  let pointsExpiringAt = value$9 !== undefined ? Scalar.Datetime.serialize(value$9) : null;
  let value$10 = value$7.points;
  let value$11 = value$7.__typename;
  let loyalty = {
    __typename: value$11,
    points: value$10,
    pointsExpiringAt: pointsExpiringAt,
    pointsExpiring: pointsExpiring
  };
  let value$12 = value.shop;
  let value$13 = value$12.loyaltyWelcomePoints;
  let loyaltyWelcomePoints = value$13 !== undefined ? value$13 : null;
  let value$14 = value$12.loyaltyPointsExpirationMonths;
  let loyaltyPointsExpirationMonths = value$14 !== undefined ? value$14 : null;
  let value$15 = value$12.id;
  let value$16 = value$12.__typename;
  let shop = {
    __typename: value$16,
    id: value$15,
    loyaltyPointsExpirationMonths: loyaltyPointsExpirationMonths,
    loyaltyWelcomePoints: loyaltyWelcomePoints
  };
  let value$17 = value.subscribedToLoyaltyProgramAt;
  let subscribedToLoyaltyProgramAt = value$17 !== undefined ? Scalar.Datetime.serialize(value$17) : null;
  let value$18 = value.hasSubscribedToLoyaltyProgram;
  let value$19 = value.__typename;
  return {
    __typename: value$19,
    hasSubscribedToLoyaltyProgram: value$18,
    subscribedToLoyaltyProgramAt: subscribedToLoyaltyProgramAt,
    shop: shop,
    loyalty: loyalty,
    unlockedVouchers: unlockedVouchers,
    lockedVouchers: lockedVouchers,
    loyaltyActivities: loyaltyActivities
  };
}
function verifyArgsAndParse$1(_CustomerDetailsLoyaltyFragment, value) {
  return parse$1(value);
}
function verifyName$1(_fragmentName) {}
let CustomerDetailsLoyaltyFragment = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  verifyArgsAndParse: verifyArgsAndParse$1,
  verifyName: verifyName$1
};
function makeReward(reward) {
  return Loyalty.makeReward(reward.kind, Stdlib_Option.map(reward.discountEvolutiveRate, param => ({
    euros: param.euros,
    points: param.points
  })), reward.discountUnit, reward.discountValue, Stdlib_Option.orElse(Stdlib_Option.map(reward.offeredVariant, param => param.formattedName), reward.offeredProductLabel));
}
function isVoucherActive(status, expectedStatus, archivedAt, rewardStatus, rewardArchivedAt) {
  if (status === expectedStatus && Stdlib_Option.isNone(archivedAt) && rewardStatus === "PUBLISHED") {
    return Stdlib_Option.isNone(rewardArchivedAt);
  } else {
    return false;
  }
}
function activeVoucherReward(voucher, expectedStatus) {
  return Stdlib_Option.filter(voucher.reward, reward => isVoucherActive(voucher.status, expectedStatus, voucher.archivedAt, reward.status, reward.archivedAt));
}
function compareEligibleRewards(current, next) {
  let match = current.willResetPoints;
  let match$1 = next.willResetPoints;
  if (match) {
    if (!match$1) {
      return 1;
    }
  } else if (match$1) {
    return -1;
  }
  return Primitive_int.compare(Stdlib_Option.getOr(current.pointsCost, 0), Stdlib_Option.getOr(next.pointsCost, 0));
}
function chunkEligibleRewards(rewards) {
  let chunkSize = rewards.length <= 2 ? 1 : 2;
  return Stdlib_Array.fromInitializer(Primitive_int.div((rewards.length + chunkSize | 0) - 1 | 0, chunkSize), index => rewards.slice(index * chunkSize | 0, (index * chunkSize | 0) + chunkSize | 0));
}
function make(fragment) {
  if (!fragment.hasSubscribedToLoyaltyProgram) {
    return;
  }
  let availablePoints = fragment.loyalty.points;
  let match = fragment.loyalty.pointsExpiringAt;
  let match$1 = fragment.loyalty.pointsExpiring;
  return {
    subscribedAt: fragment.subscribedToLoyaltyProgramAt,
    stats: {
      availablePoints: availablePoints,
      validityMonths: fragment.shop.loyaltyPointsExpirationMonths,
      nextExpiration: match !== undefined && match$1 !== undefined && match$1 > 0 ? {
        expiresAt: match,
        points: match$1
      } : undefined
    },
    eligibleRewards: Stdlib_Array.filterMap(fragment.unlockedVouchers, voucher => Stdlib_Option.flatMap(activeVoucherReward(voucher, "UNLOCKED"), fragmentReward => Stdlib_Option.map(makeReward(fragmentReward), reward => ({
      id: voucher.id,
      reward: reward,
      pointsCost: fragmentReward.pointsToUnlock,
      visitsCooldown: fragmentReward.visitsToUnlock,
      willResetPoints: fragmentReward.resetsWhenApplied
    })))).toSorted(compareEligibleRewards),
    lockedRewards: Stdlib_Array.filterMap(fragment.lockedVouchers, voucher => Stdlib_Option.flatMap(activeVoucherReward(voucher, "LOCKED"), fragmentReward => {
      let match = fragmentReward.pointsToUnlock;
      let match$1 = makeReward(fragmentReward);
      if (match !== undefined && match$1 !== undefined) {
        return {
          id: voucher.id,
          rewardId: fragmentReward.id,
          reward: match$1,
          pointsToUnlock: match,
          visitsToUnlock: fragmentReward.visitsToUnlock,
          willResetPoints: fragmentReward.resetsWhenApplied,
          progress: Loyalty.unlockProgress(availablePoints, match)
        };
      }
    })).toSorted((current, next) => Primitive_int.compare(current.pointsToUnlock, next.pointsToUnlock)),
    history: {
      totalCount: fragment.loyaltyActivities.totalCount,
      rows: CustomerDetailsLoyaltyHistoryPage.LoyaltyHistoryTableRow.groupBySalesReceipt(fragment.loyaltyActivities.edges.map(param => CustomerDetailsLoyaltyHistoryPage.LoyaltyHistoryTableRow.fromFragment(param.node)))
    }
  };
}
let Raw$2 = {};
let query$2 = Client.gql(["query CustomerDetailsLoyaltyVisitsQuery($customerId: String!, $first: Int!, $orderBy: [InputSalesReceiptsQueryOrderBy!])  {\nsalesReceipts(first: $first, filterBy: {customerId: {_in: [$customerId]}, paymentStatus: {_in: [\"PAID\"]}}, orderBy: $orderBy)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nloyaltyActivities  {\n__typename  \nid  \nreward  {\n__typename  \nid  \n}\n\n}\n\n}\n\n}\n\n}\n\n}\n"]);
function parse$2(value) {
  let value$1 = value.salesReceipts;
  let value$2 = value$1.edges;
  return {
    salesReceipts: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.loyaltyActivities;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            loyaltyActivities: value$2.map(value => {
              let value$1 = value.reward;
              return {
                __typename: value.__typename,
                id: value.id,
                reward: !(value$1 == null) ? {
                  __typename: value$1.__typename,
                  id: value$1.id
                } : undefined
              };
            })
          }
        };
      })
    }
  };
}
function serialize$2(value) {
  let value$1 = value.salesReceipts;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.loyaltyActivities;
    let loyaltyActivities = value$2.map(value => {
      let value$1 = value.reward;
      let reward;
      if (value$1 !== undefined) {
        let value$2 = value$1.id;
        let value$3 = value$1.__typename;
        reward = {
          __typename: value$3,
          id: value$2
        };
      } else {
        reward = null;
      }
      let value$4 = value.id;
      let value$5 = value.__typename;
      return {
        __typename: value$5,
        id: value$4,
        reward: reward
      };
    });
    let value$3 = value$1.id;
    let value$4 = value$1.__typename;
    let node = {
      __typename: value$4,
      id: value$3,
      loyaltyActivities: loyaltyActivities
    };
    let value$5 = value.__typename;
    return {
      __typename: value$5,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let salesReceipts = {
    __typename: value$3,
    edges: edges
  };
  return {
    salesReceipts: salesReceipts
  };
}
function serializeInputObjectInputSalesReceiptsQueryOrderBy(inp) {
  let a = inp.name;
  let a$1 = inp.createdAt;
  let a$2 = inp.totalAmountIncludingTaxes;
  return {
    name: a !== undefined ? a === "DESC" ? "DESC" : "ASC" : undefined,
    createdAt: a$1 !== undefined ? a$1 === "DESC" ? "DESC" : "ASC" : undefined,
    totalAmountIncludingTaxes: a$2 !== undefined ? a$2 === "DESC" ? "DESC" : "ASC" : undefined
  };
}
function serializeVariables(inp) {
  let a = inp.orderBy;
  return {
    customerId: inp.customerId,
    first: inp.first,
    orderBy: a !== undefined ? a.map(serializeInputObjectInputSalesReceiptsQueryOrderBy) : undefined
  };
}
function makeVariables(customerId, first, orderBy, param) {
  return {
    customerId: customerId,
    first: first,
    orderBy: orderBy
  };
}
function makeInputObjectInputSalesReceiptsQueryOrderBy(name, createdAt, totalAmountIncludingTaxes, param) {
  return {
    name: name,
    createdAt: createdAt,
    totalAmountIncludingTaxes: totalAmountIncludingTaxes
  };
}
let Query_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables,
  serializeInputObjectInputSalesReceiptsQueryOrderBy: serializeInputObjectInputSalesReceiptsQueryOrderBy,
  makeVariables: makeVariables,
  makeInputObjectInputSalesReceiptsQueryOrderBy: makeInputObjectInputSalesReceiptsQueryOrderBy
};
let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$2,
  Raw: Raw$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables
});
let use = include.use;
let Query_refetchQueryDescription = include.refetchQueryDescription;
let Query_useLazy = include.useLazy;
let Query_useLazyWithVariables = include.useLazyWithVariables;
let Query = {
  Query_inner: Query_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables,
  serializeInputObjectInputSalesReceiptsQueryOrderBy: serializeInputObjectInputSalesReceiptsQueryOrderBy,
  makeVariables: makeVariables,
  makeInputObjectInputSalesReceiptsQueryOrderBy: makeInputObjectInputSalesReceiptsQueryOrderBy,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};
function countSinceLastUse(rewardId, visitsToUnlock, receiptsRewardIds) {
  let recentReceiptsRewardIds = receiptsRewardIds.slice(0, visitsToUnlock);
  let index = recentReceiptsRewardIds.findIndex(rewardIds => rewardIds.includes(rewardId));
  if (index !== -1) {
    return index;
  } else {
    return recentReceiptsRewardIds.length;
  }
}
function withCount(loyalty, receiptsRewardIds) {
  let newrecord = {
    ...loyalty
  };
  newrecord.lockedRewards = loyalty.lockedRewards.map(lockedReward => {
    let visitsToUnlock = lockedReward.visitsToUnlock;
    if (visitsToUnlock === undefined) {
      return lockedReward;
    }
    let newrecord = {
      ...lockedReward
    };
    newrecord.visitsCount = countSinceLastUse(lockedReward.rewardId, visitsToUnlock, receiptsRewardIds);
    return newrecord;
  });
  return newrecord;
}
function receiptsRewardIdsFromData(param) {
  return param.salesReceipts.edges.map(param => Stdlib_Array.filterMap(param.node.loyaltyActivities, activity => Stdlib_Option.map(activity.reward, param => param.id)));
}
let LoyaltyVisits = {
  Query: Query,
  queryLimit: 50,
  countSinceLastUse: countSinceLastUse,
  withCount: withCount,
  receiptsRewardIdsFromData: receiptsRewardIdsFromData
};
let Raw$3 = {};
let query$3 = Client.gql(["query CustomerDetailsLoyaltyPointsActivityQuery($customerId: ID!, $gainedAfter: Datetime!, $usedAfter: Datetime!)  {\ncustomer(id: $customerId)  {\n__typename  \nid  \nloyalty  {\n__typename  \npointsGained(after: $gainedAfter)  \npointsUsed(after: $usedAfter)  \n}\n\n}\n\n}\n"]);
function parse$3(value) {
  let value$1 = value.customer;
  let value$2 = value$1.loyalty;
  return {
    customer: {
      __typename: value$1.__typename,
      id: value$1.id,
      loyalty: {
        __typename: value$2.__typename,
        pointsGained: value$2.pointsGained,
        pointsUsed: value$2.pointsUsed
      }
    }
  };
}
function serialize$3(value) {
  let value$1 = value.customer;
  let value$2 = value$1.loyalty;
  let value$3 = value$2.pointsUsed;
  let value$4 = value$2.pointsGained;
  let value$5 = value$2.__typename;
  let loyalty = {
    __typename: value$5,
    pointsGained: value$4,
    pointsUsed: value$3
  };
  let value$6 = value$1.id;
  let value$7 = value$1.__typename;
  let customer = {
    __typename: value$7,
    id: value$6,
    loyalty: loyalty
  };
  return {
    customer: customer
  };
}
function serializeVariables$1(inp) {
  return {
    customerId: inp.customerId,
    gainedAfter: inp.gainedAfter,
    usedAfter: inp.usedAfter
  };
}
function makeVariables$1(customerId, gainedAfter, usedAfter, param) {
  return {
    customerId: customerId,
    gainedAfter: gainedAfter,
    usedAfter: usedAfter
  };
}
let Query_inner$1 = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1
};
let include$1 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$3,
  Raw: Raw$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$1
});
let use$1 = include$1.use;
let Query_refetchQueryDescription$1 = include$1.refetchQueryDescription;
let Query_useLazy$1 = include$1.useLazy;
let Query_useLazyWithVariables$1 = include$1.useLazyWithVariables;
let Query$1 = {
  Query_inner: Query_inner$1,
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  refetchQueryDescription: Query_refetchQueryDescription$1,
  use: use$1,
  useLazy: Query_useLazy$1,
  useLazyWithVariables: Query_useLazyWithVariables$1
};
function withActivity(loyalty, pointsGained, pointsUsed) {
  let newrecord = {
    ...loyalty
  };
  let newrecord$1 = {
    ...loyalty.stats
  };
  newrecord$1.recentSpentPoints = pointsUsed;
  newrecord$1.recentGainedPoints = pointsGained;
  newrecord.stats = newrecord$1;
  return newrecord;
}
let LoyaltyPointsActivity = {
  Query: Query$1,
  gainedMonths: 3,
  usedMonths: 6,
  withActivity: withActivity
};
function useLoyaltyWithPointsActivity(loyalty, customerId) {
  let match = React.useMemo(() => {
    let now = new Date();
    return [DateHelpers.subMonths(now, 3), DateHelpers.subMonths(now, 6)];
  }, []);
  let queryResult = ApolloHelpers.queryResultToAsyncResult(use$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Stdlib_Option.isNone(loyalty), undefined, {
    customerId: customerId,
    gainedAfter: Scalar.Datetime.serialize(match[0]),
    usedAfter: Scalar.Datetime.serialize(match[1])
  }));
  if (loyalty === undefined) {
    return loyalty;
  }
  if (typeof queryResult !== "object") {
    return loyalty;
  }
  if (queryResult.TAG === "Reloading") {
    let match$1 = queryResult._0;
    if (match$1.TAG !== "Ok") {
      return loyalty;
    }
    let match$2 = match$1._0.customer.loyalty;
    return withActivity(loyalty, match$2.pointsGained, match$2.pointsUsed);
  }
  let match$3 = queryResult._0;
  if (match$3.TAG !== "Ok") {
    return loyalty;
  }
  let match$4 = match$3._0.customer.loyalty;
  return withActivity(loyalty, match$4.pointsGained, match$4.pointsUsed);
}
function useLoyaltyWithVisits(loyalty, customerId) {
  let maxVisitsToUnlock = Stdlib_Option.mapOr(loyalty, 0, param => Stdlib_Array.reduce(param.lockedRewards, 0, (max, param) => Math.max(max, Stdlib_Option.getOr(param.visitsToUnlock, 0))));
  let queryResult = ApolloHelpers.queryResultToAsyncResult(use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, maxVisitsToUnlock === 0, undefined, {
    customerId: customerId,
    first: Math.min(maxVisitsToUnlock, 50),
    orderBy: [{
      name: undefined,
      createdAt: "DESC",
      totalAmountIncludingTaxes: undefined
    }]
  }));
  if (loyalty === undefined) {
    return loyalty;
  }
  if (typeof queryResult !== "object") {
    return loyalty;
  }
  if (queryResult.TAG === "Reloading") {
    let data = queryResult._0;
    if (data.TAG === "Ok") {
      return withCount(loyalty, receiptsRewardIdsFromData(data._0));
    } else {
      return loyalty;
    }
  }
  let data$1 = queryResult._0;
  if (data$1.TAG === "Ok") {
    return withCount(loyalty, receiptsRewardIdsFromData(data$1._0));
  } else {
    return loyalty;
  }
}
let Raw$4 = {};
let query$4 = Client.gql(["mutation CustomerDetailsLoyaltyUnsubscribeMutation($id: ID!)  {\nunsubscribeCustomerFromLoyaltyProgram(id: $id)  {\n__typename  \nid  \nhasSubscribedToLoyaltyProgram  \n...CustomerDetailsLoyaltyFragment   \n}\n\n}\n", ""], query$1);
function parse$4(value) {
  let value$1 = value.unsubscribeCustomerFromLoyaltyProgram;
  return {
    unsubscribeCustomerFromLoyaltyProgram: {
      __typename: value$1["__typename"],
      id: value$1["id"],
      hasSubscribedToLoyaltyProgram: value$1["hasSubscribedToLoyaltyProgram"],
      customerDetailsLoyaltyFragment: parse$1(value$1)
    }
  };
}
function serialize$4(value) {
  let value$1 = value.unsubscribeCustomerFromLoyaltyProgram;
  let value$2 = value$1.hasSubscribedToLoyaltyProgram;
  let value$3 = value$1.id;
  let value$4 = value$1.__typename;
  let unsubscribeCustomerFromLoyaltyProgram = Stdlib_Array.reduce([serialize$1(value$1.customerDetailsLoyaltyFragment)], {
    __typename: value$4,
    id: value$3,
    hasSubscribedToLoyaltyProgram: value$2
  }, Graphql_ppx_runtime.deepMerge);
  return {
    unsubscribeCustomerFromLoyaltyProgram: unsubscribeCustomerFromLoyaltyProgram
  };
}
function serializeVariables$2(inp) {
  return {
    id: inp.id
  };
}
function makeVariables$2(id, param) {
  return {
    id: id
  };
}
let LoyaltyUnsubscribeMutation_inner = {
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2
};
let include$2 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$4,
  Raw: Raw$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$2
});
let use$2 = include$2.use;
let LoyaltyUnsubscribeMutation_useWithVariables = include$2.useWithVariables;
let LoyaltyUnsubscribeMutation = {
  LoyaltyUnsubscribeMutation_inner: LoyaltyUnsubscribeMutation_inner,
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  use: use$2,
  useWithVariables: LoyaltyUnsubscribeMutation_useWithVariables
};
function CustomerDetailsLoyalty$LoyaltyUnsubscribeModal(props) {
  let onRequestClose = props.onRequestClose;
  let customerId = props.customerId;
  let match = use$2(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let unsubscribe = match[0];
  let commit = () => {
    Future.tapOk(ApolloHelpers.mutationPromiseToFutureResult(unsubscribe(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      id: customerId
    })), param => onRequestClose());
  };
  return JsxRuntime.jsx(Modal.make, {
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("Once unsubscribed, the customer will no longer earn points nor benefit from rewards."),
        variation: "normal"
      }),
      spaceX: "xlarge",
      spaceY: "xxlarge"
    }),
    opened: props.opened,
    title: I18n.t("Confirm the unsubscription from the loyalty program"),
    abortButtonText: I18n.t("Cancel"),
    commitButtonTone: "danger",
    commitButtonText: I18n.t("Unsubscribe"),
    commitButtonCallback: commit,
    commitButtonPending: match[1].loading,
    closeOnCommit: false,
    onRequestClose: onRequestClose
  });
}
let LoyaltyUnsubscribeModal = {
  LoyaltyUnsubscribeMutation: LoyaltyUnsubscribeMutation,
  make: CustomerDetailsLoyalty$LoyaltyUnsubscribeModal
};
let i18nPrefix = "customer_details_loyalty.points_edit_modal.";
let Raw$5 = {};
let query$5 = Client.gql(["mutation CustomerDetailsLoyaltyPointsMutation($points: Int!, $customerId: String!, $shopId: String!)  {\ncreateLoyaltyActivity(kind: RESET, points: $points, customerId: $customerId, shopId: $shopId)  {\n__typename  \nid  \ncustomer  {\n__typename  \nid  \n...CustomerDetailsLoyaltyFragment   \n}\n\n}\n\n}\n", ""], query$1);
function parse$5(value) {
  let value$1 = value.createLoyaltyActivity;
  let value$2 = value$1.customer;
  return {
    createLoyaltyActivity: {
      __typename: value$1.__typename,
      id: value$1.id,
      customer: !(value$2 == null) ? {
        __typename: value$2["__typename"],
        id: value$2["id"],
        customerDetailsLoyaltyFragment: parse$1(value$2)
      } : undefined
    }
  };
}
function serialize$5(value) {
  let value$1 = value.createLoyaltyActivity;
  let value$2 = value$1.customer;
  let customer;
  if (value$2 !== undefined) {
    let value$3 = value$2.id;
    let value$4 = value$2.__typename;
    customer = Stdlib_Array.reduce([serialize$1(value$2.customerDetailsLoyaltyFragment)], {
      __typename: value$4,
      id: value$3
    }, Graphql_ppx_runtime.deepMerge);
  } else {
    customer = null;
  }
  let value$5 = value$1.id;
  let value$6 = value$1.__typename;
  let createLoyaltyActivity = {
    __typename: value$6,
    id: value$5,
    customer: customer
  };
  return {
    createLoyaltyActivity: createLoyaltyActivity
  };
}
function serializeVariables$3(inp) {
  return {
    points: inp.points,
    customerId: inp.customerId,
    shopId: inp.shopId
  };
}
function makeVariables$3(points, customerId, shopId, param) {
  return {
    points: points,
    customerId: customerId,
    shopId: shopId
  };
}
let LoyaltyPointsMutation_inner = {
  Raw: Raw$5,
  query: query$5,
  parse: parse$5,
  serialize: serialize$5,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3
};
let include$3 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$5,
  Raw: Raw$5,
  parse: parse$5,
  serialize: serialize$5,
  serializeVariables: serializeVariables$3
});
let use$3 = include$3.use;
let LoyaltyPointsMutation_useWithVariables = include$3.useWithVariables;
let LoyaltyPointsMutation = {
  LoyaltyPointsMutation_inner: LoyaltyPointsMutation_inner,
  Raw: Raw$5,
  query: query$5,
  parse: parse$5,
  serialize: serialize$5,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3,
  use: use$3,
  useWithVariables: LoyaltyPointsMutation_useWithVariables
};
function CustomerDetailsLoyalty$LoyaltyPointsEditModal(props) {
  let onRequestClose = props.onRequestClose;
  let opened = props.opened;
  let currentPoints = props.currentPoints;
  let shopId = props.shopId;
  let customerId = props.customerId;
  let match = use$3(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let createLoyaltyActivity = match[0];
  let match$1 = React.useState(() => currentPoints);
  let setTargetPoints = match$1[1];
  let targetPoints = match$1[0];
  React.useEffect(() => {
    if (opened) {
      setTargetPoints(param => currentPoints);
    }
  }, [opened, currentPoints]);
  let commit = () => {
    Future.tapOk(ApolloHelpers.mutationPromiseToFutureResult(createLoyaltyActivity(undefined, undefined, undefined, undefined, undefined, [{
      TAG: "String",
      _0: "CustomerDetailsQuery"
    }], undefined, {
      points: targetPoints,
      customerId: customerId,
      shopId: shopId
    })), param => onRequestClose());
  };
  return JsxRuntime.jsx(Modal.make, {
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t(i18nPrefix + "description")
        }), JsxRuntime.jsx(InputNumberField.make, {
          value: targetPoints,
          minValue: 0,
          precision: 0,
          label: I18n.t(i18nPrefix + "points_field.label"),
          placeholder: I18n.t(i18nPrefix + "points_field.placeholder"),
          appender: {
            TAG: "Custom",
            _0: I18n.t("pts")
          },
          autoFocused: true,
          onChange: value => setTargetPoints(param => value | 0)
        })],
        space: "large"
      }),
      spaceX: "xlarge",
      spaceY: "xxlarge"
    }),
    opened: opened,
    title: I18n.t("Edit loyalty points"),
    abortButtonText: I18n.t("Cancel"),
    allowCommit: targetPoints !== currentPoints,
    commitButtonTone: "success",
    commitButtonText: I18n.t("Save"),
    commitButtonCallback: commit,
    commitButtonPending: match[1].loading,
    closeOnCommit: false,
    onRequestClose: onRequestClose
  });
}
let LoyaltyPointsEditModal = {
  i18nPrefix: i18nPrefix,
  LoyaltyPointsMutation: LoyaltyPointsMutation,
  make: CustomerDetailsLoyalty$LoyaltyPointsEditModal
};
let Raw$6 = {};
let query$6 = Client.gql(["query CustomerDetailsLoyaltySubscribeQuery($customerId: ID!)  {\ncustomer(id: $customerId)  {\n__typename  \nid  \nfirstName  \nlastName  \ncompanyName  \nintraCommunityVAT  \nemail  \nphoneNumber  \nmobileNumber  \nnote  \nsiret  \ninternalCode  \ninvoicingEndpointId  \ninvoicingEndpointIdSchemeCode  \ninvoicingEndpointIdSchemeType  \ndateOfBirth  \nprice  {\n__typename  \nid  \n}\n\nshop  {\n__typename  \nid  \nloyaltyWelcomePoints  \n}\n\n}\n\n}\n"]);
function parse$6(value) {
  let value$1 = value.customer;
  let value$2 = value$1.firstName;
  let value$3 = value$1.lastName;
  let value$4 = value$1.companyName;
  let value$5 = value$1.intraCommunityVAT;
  let value$6 = value$1.email;
  let value$7 = value$1.phoneNumber;
  let value$8 = value$1.mobileNumber;
  let value$9 = value$1.note;
  let value$10 = value$1.siret;
  let value$11 = value$1.internalCode;
  let value$12 = value$1.invoicingEndpointId;
  let value$13 = value$1.invoicingEndpointIdSchemeCode;
  let value$14 = value$1.invoicingEndpointIdSchemeType;
  let tmp;
  if (value$14 == null) {
    tmp = undefined;
  } else {
    let tmp$1;
    switch (value$14) {
      case "BE_BCE":
        tmp$1 = "BE_BCE";
        break;
      case "BE_TVA":
        tmp$1 = "BE_TVA";
        break;
      case "FR_SIREN":
        tmp$1 = "FR_SIREN";
        break;
      case "FR_SIREN_SIRET":
        tmp$1 = "FR_SIREN_SIRET";
        break;
      case "FR_SIREN_SIRET_CODEROUTAGE":
        tmp$1 = "FR_SIREN_SIRET_CODEROUTAGE";
        break;
      case "FR_SIREN_SUFFIX":
        tmp$1 = "FR_SIREN_SUFFIX";
        break;
      default:
        throw {
          RE_EXN_ID: "Not_found",
          Error: new Error()
        };
    }
    tmp = tmp$1;
  }
  let value$15 = value$1.dateOfBirth;
  let value$16 = value$1.price;
  let value$17 = value$1.shop;
  let value$18 = value$17.loyaltyWelcomePoints;
  return {
    customer: {
      __typename: value$1.__typename,
      id: value$1.id,
      firstName: !(value$2 == null) ? value$2 : undefined,
      lastName: !(value$3 == null) ? value$3 : undefined,
      companyName: !(value$4 == null) ? value$4 : undefined,
      intraCommunityVAT: !(value$5 == null) ? value$5 : undefined,
      email: !(value$6 == null) ? value$6 : undefined,
      phoneNumber: !(value$7 == null) ? value$7 : undefined,
      mobileNumber: !(value$8 == null) ? value$8 : undefined,
      note: !(value$9 == null) ? value$9 : undefined,
      siret: !(value$10 == null) ? value$10 : undefined,
      internalCode: !(value$11 == null) ? value$11 : undefined,
      invoicingEndpointId: !(value$12 == null) ? value$12 : undefined,
      invoicingEndpointIdSchemeCode: !(value$13 == null) ? value$13 : undefined,
      invoicingEndpointIdSchemeType: tmp,
      dateOfBirth: !(value$15 == null) ? Scalar.Datetime.parse(value$15) : undefined,
      price: !(value$16 == null) ? {
        __typename: value$16.__typename,
        id: value$16.id
      } : undefined,
      shop: {
        __typename: value$17.__typename,
        id: value$17.id,
        loyaltyWelcomePoints: !(value$18 == null) ? value$18 : undefined
      }
    }
  };
}
function serialize$6(value) {
  let value$1 = value.customer;
  let value$2 = value$1.shop;
  let value$3 = value$2.loyaltyWelcomePoints;
  let loyaltyWelcomePoints = value$3 !== undefined ? value$3 : null;
  let value$4 = value$2.id;
  let value$5 = value$2.__typename;
  let shop = {
    __typename: value$5,
    id: value$4,
    loyaltyWelcomePoints: loyaltyWelcomePoints
  };
  let value$6 = value$1.price;
  let price;
  if (value$6 !== undefined) {
    let value$7 = value$6.id;
    let value$8 = value$6.__typename;
    price = {
      __typename: value$8,
      id: value$7
    };
  } else {
    price = null;
  }
  let value$9 = value$1.dateOfBirth;
  let dateOfBirth = value$9 !== undefined ? Scalar.Datetime.serialize(value$9) : null;
  let value$10 = value$1.invoicingEndpointIdSchemeType;
  let invoicingEndpointIdSchemeType = value$10 !== undefined ? value$10 === "BE_TVA" ? "BE_TVA" : value$10 === "FR_SIREN" ? "FR_SIREN" : value$10 === "FR_SIREN_SIRET_CODEROUTAGE" ? "FR_SIREN_SIRET_CODEROUTAGE" : value$10 === "FR_SIREN_SUFFIX" ? "FR_SIREN_SUFFIX" : value$10 === "FR_SIREN_SIRET" ? "FR_SIREN_SIRET" : "BE_BCE" : null;
  let value$11 = value$1.invoicingEndpointIdSchemeCode;
  let invoicingEndpointIdSchemeCode = value$11 !== undefined ? value$11 : null;
  let value$12 = value$1.invoicingEndpointId;
  let invoicingEndpointId = value$12 !== undefined ? value$12 : null;
  let value$13 = value$1.internalCode;
  let internalCode = value$13 !== undefined ? value$13 : null;
  let value$14 = value$1.siret;
  let siret = value$14 !== undefined ? value$14 : null;
  let value$15 = value$1.note;
  let note = value$15 !== undefined ? value$15 : null;
  let value$16 = value$1.mobileNumber;
  let mobileNumber = value$16 !== undefined ? value$16 : null;
  let value$17 = value$1.phoneNumber;
  let phoneNumber = value$17 !== undefined ? value$17 : null;
  let value$18 = value$1.email;
  let email = value$18 !== undefined ? value$18 : null;
  let value$19 = value$1.intraCommunityVAT;
  let intraCommunityVAT = value$19 !== undefined ? value$19 : null;
  let value$20 = value$1.companyName;
  let companyName = value$20 !== undefined ? value$20 : null;
  let value$21 = value$1.lastName;
  let lastName = value$21 !== undefined ? value$21 : null;
  let value$22 = value$1.firstName;
  let firstName = value$22 !== undefined ? value$22 : null;
  let value$23 = value$1.id;
  let value$24 = value$1.__typename;
  let customer = {
    __typename: value$24,
    id: value$23,
    firstName: firstName,
    lastName: lastName,
    companyName: companyName,
    intraCommunityVAT: intraCommunityVAT,
    email: email,
    phoneNumber: phoneNumber,
    mobileNumber: mobileNumber,
    note: note,
    siret: siret,
    internalCode: internalCode,
    invoicingEndpointId: invoicingEndpointId,
    invoicingEndpointIdSchemeCode: invoicingEndpointIdSchemeCode,
    invoicingEndpointIdSchemeType: invoicingEndpointIdSchemeType,
    dateOfBirth: dateOfBirth,
    price: price,
    shop: shop
  };
  return {
    customer: customer
  };
}
function serializeVariables$4(inp) {
  return {
    customerId: inp.customerId
  };
}
function makeVariables$4(customerId, param) {
  return {
    customerId: customerId
  };
}
let LoyaltySubscribeQuery_inner = {
  Raw: Raw$6,
  query: query$6,
  parse: parse$6,
  serialize: serialize$6,
  serializeVariables: serializeVariables$4,
  makeVariables: makeVariables$4
};
let include$4 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$6,
  Raw: Raw$6,
  parse: parse$6,
  serialize: serialize$6,
  serializeVariables: serializeVariables$4
});
let use$4 = include$4.use;
let LoyaltySubscribeQuery_refetchQueryDescription = include$4.refetchQueryDescription;
let LoyaltySubscribeQuery_useLazy = include$4.useLazy;
let LoyaltySubscribeQuery_useLazyWithVariables = include$4.useLazyWithVariables;
let LoyaltySubscribeQuery = {
  LoyaltySubscribeQuery_inner: LoyaltySubscribeQuery_inner,
  Raw: Raw$6,
  query: query$6,
  parse: parse$6,
  serialize: serialize$6,
  serializeVariables: serializeVariables$4,
  makeVariables: makeVariables$4,
  refetchQueryDescription: LoyaltySubscribeQuery_refetchQueryDescription,
  use: use$4,
  useLazy: LoyaltySubscribeQuery_useLazy,
  useLazyWithVariables: LoyaltySubscribeQuery_useLazyWithVariables
};
let Raw$7 = {};
let query$7 = Client.gql(["mutation CustomerDetailsLoyaltySubscribeCustomerUpdateMutation($id: ID!, $customerInput: InputUpdateCustomerTypeDef)  {\nupdateCustomer(id: $id, customerInput: $customerInput)  {\n__typename  \nid  \nemail  \ndateOfBirth  \nupdatedAt  \n}\n\n}\n"]);
function parse$7(value) {
  let value$1 = value.updateCustomer;
  let value$2 = value$1.email;
  let value$3 = value$1.dateOfBirth;
  return {
    updateCustomer: {
      __typename: value$1.__typename,
      id: value$1.id,
      email: !(value$2 == null) ? value$2 : undefined,
      dateOfBirth: !(value$3 == null) ? Scalar.Datetime.parse(value$3) : undefined,
      updatedAt: Scalar.Datetime.parse(value$1.updatedAt)
    }
  };
}
function serialize$7(value) {
  let value$1 = value.updateCustomer;
  let value$2 = value$1.updatedAt;
  let value$3 = Scalar.Datetime.serialize(value$2);
  let value$4 = value$1.dateOfBirth;
  let dateOfBirth = value$4 !== undefined ? Scalar.Datetime.serialize(value$4) : null;
  let value$5 = value$1.email;
  let email = value$5 !== undefined ? value$5 : null;
  let value$6 = value$1.id;
  let value$7 = value$1.__typename;
  let updateCustomer = {
    __typename: value$7,
    id: value$6,
    email: email,
    dateOfBirth: dateOfBirth,
    updatedAt: value$3
  };
  return {
    updateCustomer: updateCustomer
  };
}
function serializeInputObjectInputUpdateCustomerTypeDef(inp) {
  let a = inp.priceId;
  let a$1 = inp.companyName;
  let a$2 = inp.intraCommunityVAT;
  let a$3 = inp.firstName;
  let a$4 = inp.lastName;
  let a$5 = inp.email;
  let a$6 = inp.phoneNumber;
  let a$7 = inp.mobileNumber;
  let a$8 = inp.note;
  let a$9 = inp.siret;
  let a$10 = inp.internalCode;
  let a$11 = inp.invoicingEndpointId;
  let a$12 = inp.invoicingEndpointIdSchemeCode;
  let a$13 = inp.invoicingEndpointIdSchemeType;
  let a$14 = inp.dateOfBirth;
  return {
    priceId: a !== undefined ? a : undefined,
    companyName: a$1 !== undefined ? a$1 : undefined,
    intraCommunityVAT: a$2 !== undefined ? a$2 : undefined,
    firstName: a$3 !== undefined ? a$3 : undefined,
    lastName: a$4 !== undefined ? a$4 : undefined,
    email: a$5 !== undefined ? a$5 : undefined,
    phoneNumber: a$6 !== undefined ? a$6 : undefined,
    mobileNumber: a$7 !== undefined ? a$7 : undefined,
    note: a$8 !== undefined ? a$8 : undefined,
    siret: a$9 !== undefined ? a$9 : undefined,
    internalCode: a$10 !== undefined ? a$10 : undefined,
    invoicingEndpointId: a$11 !== undefined ? a$11 : undefined,
    invoicingEndpointIdSchemeCode: a$12 !== undefined ? a$12 : undefined,
    invoicingEndpointIdSchemeType: a$13 !== undefined ? a$13 === "BE_TVA" ? "BE_TVA" : a$13 === "FR_SIREN" ? "FR_SIREN" : a$13 === "FR_SIREN_SIRET_CODEROUTAGE" ? "FR_SIREN_SIRET_CODEROUTAGE" : a$13 === "FR_SIREN_SUFFIX" ? "FR_SIREN_SUFFIX" : a$13 === "FR_SIREN_SIRET" ? "FR_SIREN_SIRET" : "BE_BCE" : undefined,
    dateOfBirth: a$14 !== undefined ? a$14 : undefined
  };
}
function serializeVariables$5(inp) {
  let a = inp.customerInput;
  return {
    id: inp.id,
    customerInput: a !== undefined ? serializeInputObjectInputUpdateCustomerTypeDef(a) : undefined
  };
}
function makeVariables$5(id, customerInput, param) {
  return {
    id: id,
    customerInput: customerInput
  };
}
function makeInputObjectInputUpdateCustomerTypeDef(priceId, companyName, intraCommunityVAT, firstName, lastName, email, phoneNumber, mobileNumber, note, siret, internalCode, invoicingEndpointId, invoicingEndpointIdSchemeCode, invoicingEndpointIdSchemeType, dateOfBirth, param) {
  return {
    priceId: priceId,
    companyName: companyName,
    intraCommunityVAT: intraCommunityVAT,
    firstName: firstName,
    lastName: lastName,
    email: email,
    phoneNumber: phoneNumber,
    mobileNumber: mobileNumber,
    note: note,
    siret: siret,
    internalCode: internalCode,
    invoicingEndpointId: invoicingEndpointId,
    invoicingEndpointIdSchemeCode: invoicingEndpointIdSchemeCode,
    invoicingEndpointIdSchemeType: invoicingEndpointIdSchemeType,
    dateOfBirth: dateOfBirth
  };
}
let LoyaltySubscribeCustomerUpdateMutation_inner = {
  Raw: Raw$7,
  query: query$7,
  parse: parse$7,
  serialize: serialize$7,
  serializeVariables: serializeVariables$5,
  serializeInputObjectInputUpdateCustomerTypeDef: serializeInputObjectInputUpdateCustomerTypeDef,
  makeVariables: makeVariables$5,
  makeInputObjectInputUpdateCustomerTypeDef: makeInputObjectInputUpdateCustomerTypeDef
};
let include$5 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$7,
  Raw: Raw$7,
  parse: parse$7,
  serialize: serialize$7,
  serializeVariables: serializeVariables$5
});
let use$5 = include$5.use;
let LoyaltySubscribeCustomerUpdateMutation_useWithVariables = include$5.useWithVariables;
let LoyaltySubscribeCustomerUpdateMutation = {
  LoyaltySubscribeCustomerUpdateMutation_inner: LoyaltySubscribeCustomerUpdateMutation_inner,
  Raw: Raw$7,
  query: query$7,
  parse: parse$7,
  serialize: serialize$7,
  serializeVariables: serializeVariables$5,
  serializeInputObjectInputUpdateCustomerTypeDef: serializeInputObjectInputUpdateCustomerTypeDef,
  makeVariables: makeVariables$5,
  makeInputObjectInputUpdateCustomerTypeDef: makeInputObjectInputUpdateCustomerTypeDef,
  use: use$5,
  useWithVariables: LoyaltySubscribeCustomerUpdateMutation_useWithVariables
};
let Raw$8 = {};
let query$8 = Client.gql(["mutation CustomerDetailsLoyaltySubscribeMutation($id: ID!, $isLoyaltyConsentGiven: Boolean!)  {\nsubscribeCustomerToLoyaltyProgram(id: $id, isLoyaltyConsentGiven: $isLoyaltyConsentGiven)  {\n__typename  \nid  \nhasSubscribedToLoyaltyProgram  \n...CustomerDetailsLoyaltyFragment   \n}\n\n}\n", ""], query$1);
function parse$8(value) {
  let value$1 = value.subscribeCustomerToLoyaltyProgram;
  return {
    subscribeCustomerToLoyaltyProgram: {
      __typename: value$1["__typename"],
      id: value$1["id"],
      hasSubscribedToLoyaltyProgram: value$1["hasSubscribedToLoyaltyProgram"],
      customerDetailsLoyaltyFragment: parse$1(value$1)
    }
  };
}
function serialize$8(value) {
  let value$1 = value.subscribeCustomerToLoyaltyProgram;
  let value$2 = value$1.hasSubscribedToLoyaltyProgram;
  let value$3 = value$1.id;
  let value$4 = value$1.__typename;
  let subscribeCustomerToLoyaltyProgram = Stdlib_Array.reduce([serialize$1(value$1.customerDetailsLoyaltyFragment)], {
    __typename: value$4,
    id: value$3,
    hasSubscribedToLoyaltyProgram: value$2
  }, Graphql_ppx_runtime.deepMerge);
  return {
    subscribeCustomerToLoyaltyProgram: subscribeCustomerToLoyaltyProgram
  };
}
function serializeVariables$6(inp) {
  return {
    id: inp.id,
    isLoyaltyConsentGiven: inp.isLoyaltyConsentGiven
  };
}
function makeVariables$6(id, isLoyaltyConsentGiven, param) {
  return {
    id: id,
    isLoyaltyConsentGiven: isLoyaltyConsentGiven
  };
}
let LoyaltySubscribeMutation_inner = {
  Raw: Raw$8,
  query: query$8,
  parse: parse$8,
  serialize: serialize$8,
  serializeVariables: serializeVariables$6,
  makeVariables: makeVariables$6
};
let include$6 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$8,
  Raw: Raw$8,
  parse: parse$8,
  serialize: serialize$8,
  serializeVariables: serializeVariables$6
});
let use$6 = include$6.use;
let LoyaltySubscribeMutation_useWithVariables = include$6.useWithVariables;
let LoyaltySubscribeMutation = {
  LoyaltySubscribeMutation_inner: LoyaltySubscribeMutation_inner,
  Raw: Raw$8,
  query: query$8,
  parse: parse$8,
  serialize: serialize$8,
  serializeVariables: serializeVariables$6,
  makeVariables: makeVariables$6,
  use: use$6,
  useWithVariables: LoyaltySubscribeMutation_useWithVariables
};
function get(values, field) {
  switch (field) {
    case "Email":
      return values.email;
    case "DateOfBirth":
      return values.dateOfBirth;
    case "IsConsentGiven":
      return values.isConsentGiven;
  }
}
function set(values, field, value) {
  switch (field) {
    case "Email":
      return {
        email: value,
        dateOfBirth: values.dateOfBirth,
        isConsentGiven: values.isConsentGiven
      };
    case "DateOfBirth":
      return {
        email: values.email,
        dateOfBirth: value,
        isConsentGiven: values.isConsentGiven
      };
    case "IsConsentGiven":
      return {
        email: values.email,
        dateOfBirth: values.dateOfBirth,
        isConsentGiven: value
      };
  }
}
let Lenses = {
  get: get,
  set: set
};
let LoyaltySubscribeFormLenses = {
  Lenses: Lenses,
  get: get,
  set: set
};
let LoyaltySubscribeForm = Form.Make({
  get: get,
  set: set
});
let i18nPrefix$1 = "customer_details_loyalty.subscribe_modal.";
function orNull(option) {
  return Stdlib_Option.getOr(option, null);
}
function customerInputFromCustomer(customer, email, dateOfBirth) {
  return makeInputObjectInputUpdateCustomerTypeDef(Stdlib_Option.map(customer.price, param => param.id), customer.companyName, customer.intraCommunityVAT, customer.firstName, customer.lastName, Stdlib_Option.getOr(email, null), customer.phoneNumber, customer.mobileNumber, customer.note, customer.siret, customer.internalCode, customer.invoicingEndpointId, customer.invoicingEndpointIdSchemeCode, customer.invoicingEndpointIdSchemeType, Stdlib_Option.getOr(Stdlib_Option.map(dateOfBirth, Scalar.Datetime.serialize), null), undefined);
}
let schema = [{
  TAG: "Email",
  _0: "Email"
}, {
  TAG: "Custom",
  _0: "IsConsentGiven",
  _1: param => {
    if (param.isConsentGiven) {
      return {
        TAG: "Ok",
        _0: undefined
      };
    } else {
      return {
        TAG: "Error",
        _0: I18n.t(i18nPrefix$1 + "consent_field.error")
      };
    }
  }
}];
let styles = {
  illustrationContainer: {
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "height-kZKoxP": "height-xjp8j0k",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "width-kzqmXN": "width-x13oubkp",
    $$css: "wino-gc:src/modules/Customer/CustomerDetailsLoyalty.res.js:1721"
  }
};
let illustrationStyle = {
  display: "block",
  height: "80%",
  width: "80%",
  objectFit: "contain"
};
function CustomerDetailsLoyalty$LoyaltySubscribeModal$LoyaltyWelcomePointsTile(props) {
  return JsxRuntime.jsx(CanarySurface.make, {
    tone: "brand",
    borderColor: "#A01E72",
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsxs(Inline.make, {
        children: [JsxRuntime.jsx(CanarySurface.make, {
          tone: "brand",
          shrink: false,
          children: JsxRuntime.jsx(Box.make, {
            children: JsxRuntime.jsx("img", {
              style: illustrationStyle,
              alt: "",
              src: Illustration.loyaltySrc
            }),
            style: Primitive_option.some(styles.illustrationContainer)
          })
        }), JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsx(Title.make, {
            children: I18n.template(I18n.t(i18nPrefix$1 + "welcome_points.title"), {
              points: Loyalty.formatePoints(undefined, props.points)
            }, undefined),
            level: 2,
            color: "#A01E72"
          }), JsxRuntime.jsx(TextStyle.make, {
            children: I18n.t(i18nPrefix$1 + "welcome_points.subtitle"),
            variation: {
              NAME: "custom",
              VAL: "#25243A"
            },
            size: "small"
          })],
          space: "xsmall"
        })],
        space: "xlarge",
        alignY: "center"
      }),
      spaceX: "large",
      spaceY: "large"
    })
  });
}
let LoyaltyWelcomePointsTile = {
  styles: styles,
  illustrationStyle: illustrationStyle,
  make: CustomerDetailsLoyalty$LoyaltySubscribeModal$LoyaltyWelcomePointsTile
};
function CustomerDetailsLoyalty$LoyaltySubscribeModal$LoyaltyConsentField(props) {
  let match = LoyaltySubscribeForm.useField("IsConsentGiven", undefined, undefined, true, undefined);
  return JsxRuntime.jsx(InputCheckboxField.make, {
    text: I18n.t(i18nPrefix$1 + "consent_field.text") + " *",
    errorMessage: match.error,
    value: match.value,
    onChange: match.onChange
  });
}
let LoyaltyConsentField = {
  make: CustomerDetailsLoyalty$LoyaltySubscribeModal$LoyaltyConsentField
};
function isSameOptionalDate(current, next) {
  if (current !== undefined) {
    if (next !== undefined) {
      return DateHelpers.isSameDay(current, next);
    } else {
      return false;
    }
  } else {
    return next === undefined;
  }
}
function CustomerDetailsLoyalty$LoyaltySubscribeModal$LoyaltySubscribeModalForm(props) {
  let onRequestClose = props.onRequestClose;
  let customer = props.customer;
  let match = use$5(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let updateCustomer = match[0];
  let match$1 = use$6(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let subscribe = match$1[0];
  let match$2 = React.useState(() => {});
  let setErrorMessage = match$2[1];
  let errorMessage = match$2[0];
  let onSubmit = (param, param$1) => {
    let isConsentGiven = param$1.isConsentGiven;
    let dateOfBirth = param$1.dateOfBirth;
    let email = StringHelpers.stripEmptyString(param$1.email);
    let customerUpdated = email !== customer.email || !isSameOptionalDate(dateOfBirth, customer.dateOfBirth);
    let customerUpdate = customerUpdated ? Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(updateCustomer(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      id: customer.id,
      customerInput: customerInputFromCustomer(customer, email, dateOfBirth)
    })), undefined, param => {}) : Future.value({
      TAG: "Ok",
      _0: undefined
    });
    return Future.mapOk(Future.flatMapOk(customerUpdate, undefined, () => ApolloHelpers.mutationPromiseToFutureResult(subscribe(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      id: customer.id,
      isLoyaltyConsentGiven: isConsentGiven
    }))), undefined, param => {});
  };
  let propState = LoyaltySubscribeForm.useFormPropState({
    initialValues: {
      email: Stdlib_Option.getOr(customer.email, ""),
      dateOfBirth: customer.dateOfBirth,
      isConsentGiven: false
    },
    schema: schema,
    onSubmitFailure: message => setErrorMessage(param => message),
    onSubmitSuccess: param => onRequestClose()
  });
  let dispatch = propState[1];
  let points = customer.shop.loyaltyWelcomePoints;
  return JsxRuntime.jsx(LoyaltySubscribeForm.Core.Provider.make, {
    children: JsxRuntime.jsx(Modal.make, {
      children: JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsx(TextStyle.make, {
            children: I18n.t(i18nPrefix$1 + "description"),
            variation: {
              NAME: "custom",
              VAL: "#25243A"
            },
            size: "normal"
          }), errorMessage !== undefined ? JsxRuntime.jsx(NextBanner.make, {
            children: JsxRuntime.jsx(NextBanner.Text.make, {
              text: errorMessage
            }),
            variation: "danger"
          }) : null, JsxRuntime.jsxs(Stack.make, {
            children: [JsxRuntime.jsx(LoyaltySubscribeForm.InputText.make, {
              field: "Email",
              label: I18n.t(i18nPrefix$1 + "email_field.label"),
              placeholder: I18n.t("monadresse@email.com")
            }), JsxRuntime.jsx(LoyaltySubscribeForm.InputOptionalDateFastNav.make, {
              label: I18n.t(i18nPrefix$1 + "date_of_birth_field.label"),
              field: "DateOfBirth",
              disabledFutureDays: true
            }), JsxRuntime.jsx(Box.make, {
              children: JsxRuntime.jsx(CustomerDetailsLoyalty$LoyaltySubscribeModal$LoyaltyConsentField, {}),
              spaceTop: "small"
            })],
            space: "large"
          }), points !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [JsxRuntime.jsx(CanarySeparator.make, {
              orientation: "horizontal"
            }), JsxRuntime.jsx(TextStyle.make, {
              children: I18n.t(i18nPrefix$1 + "welcome_points.reminder"),
              variation: {
                NAME: "custom",
                VAL: "#25243A"
              },
              size: "normal"
            }), JsxRuntime.jsx(CustomerDetailsLoyalty$LoyaltySubscribeModal$LoyaltyWelcomePointsTile, {
              points: points
            })]
          }) : null],
          space: "xlarge"
        }),
        spaceX: "xlarge",
        spaceY: "xlarge"
      }),
      opened: true,
      title: I18n.t(i18nPrefix$1 + "title"),
      variation: "secondary",
      width: "600px",
      renderStartText: () => JsxRuntime.jsx("div", {}),
      abortButtonText: I18n.t("Cancel"),
      commitButtonText: I18n.t(i18nPrefix$1 + "commit_button.label"),
      commitButtonCallback: () => {
        setErrorMessage(param => {});
        dispatch({
          TAG: "SubmitButtonClicked",
          _0: onSubmit
        });
      },
      commitButtonPending: Form__Submission.isRequested(propState[0].submission),
      closeOnCommit: false,
      onRequestClose: onRequestClose
    }),
    propState: propState
  });
}
let LoyaltySubscribeModalForm = {
  make: CustomerDetailsLoyalty$LoyaltySubscribeModal$LoyaltySubscribeModalForm
};
function CustomerDetailsLoyalty$LoyaltySubscribeModal(props) {
  let onRequestClose = props.onRequestClose;
  let opened = props.opened;
  let queryResult = ApolloHelpers.queryResultToAsyncResult(use$4(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, !opened, undefined, {
    customerId: props.customerId
  }));
  if (!opened) {
    return null;
  }
  let exit = 0;
  if (typeof queryResult !== "object") {
    exit = 2;
  } else if (queryResult.TAG === "Reloading") {
    let match = queryResult._0;
    if (match.TAG === "Ok") {
      return JsxRuntime.jsx(CustomerDetailsLoyalty$LoyaltySubscribeModal$LoyaltySubscribeModalForm, {
        customer: match._0.customer,
        onRequestClose: onRequestClose
      });
    }
    exit = 1;
  } else {
    let match$1 = queryResult._0;
    if (match$1.TAG === "Ok") {
      return JsxRuntime.jsx(CustomerDetailsLoyalty$LoyaltySubscribeModal$LoyaltySubscribeModalForm, {
        customer: match$1._0.customer,
        onRequestClose: onRequestClose
      });
    }
    exit = 1;
  }
  switch (exit) {
    case 1:
      return JsxRuntime.jsx(Modal.make, {
        children: JsxRuntime.jsx(Placeholder.make, {
          status: "Error"
        }),
        opened: opened,
        title: I18n.t(i18nPrefix$1 + "title"),
        onRequestClose: onRequestClose
      });
    case 2:
      return JsxRuntime.jsx(Modal.make, {
        children: JsxRuntime.jsx(Placeholder.make, {
          status: "Loading"
        }),
        opened: opened,
        title: I18n.t(i18nPrefix$1 + "title"),
        onRequestClose: onRequestClose
      });
  }
}
let LoyaltySubscribeModal = {
  LoyaltySubscribeFormLenses: LoyaltySubscribeFormLenses,
  LoyaltySubscribeForm: LoyaltySubscribeForm,
  i18nPrefix: i18nPrefix$1,
  orNull: orNull,
  customerInputFromCustomer: customerInputFromCustomer,
  schema: schema,
  LoyaltyWelcomePointsTile: LoyaltyWelcomePointsTile,
  LoyaltyConsentField: LoyaltyConsentField,
  isSameOptionalDate: isSameOptionalDate,
  LoyaltySubscribeModalForm: LoyaltySubscribeModalForm,
  make: CustomerDetailsLoyalty$LoyaltySubscribeModal
};
function CustomerDetailsLoyalty$LoyaltyActions(props) {
  let customerId = props.customerId;
  let match = React.useState(() => {});
  let setOpenedModal = match[1];
  let openedModal = match[0];
  let onRequestClose = () => setOpenedModal(param => {});
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsx(Button.make, {
        label: I18n.t("Unsubscribe the customer"),
        variant: {
          NAME: "ghost",
          VAL: {
            bordered: true
          }
        },
        tone: "danger",
        grow: true,
        icon: "cross",
        onPress: () => setOpenedModal(param => "Unsubscribe")
      }), JsxRuntime.jsx(Button.make, {
        label: I18n.t("Change the number of points"),
        variant: {
          NAME: "ghost",
          VAL: {
            bordered: true
          }
        },
        grow: true,
        icon: "edit",
        onPress: () => setOpenedModal(param => "PointsEdit")
      })],
      space: "medium",
      align: "end"
    }), JsxRuntime.jsx(CustomerDetailsLoyalty$LoyaltyUnsubscribeModal, {
      customerId: customerId,
      opened: openedModal === "Unsubscribe",
      onRequestClose: onRequestClose
    }), JsxRuntime.jsx(CustomerDetailsLoyalty$LoyaltyPointsEditModal, {
      customerId: customerId,
      shopId: props.shopId,
      currentPoints: props.currentPoints,
      opened: openedModal === "PointsEdit",
      onRequestClose: onRequestClose
    })]
  });
}
let LoyaltyActions = {
  make: CustomerDetailsLoyalty$LoyaltyActions
};
function CustomerDetailsLoyalty$Tabview$LoyaltySection(props) {
  let __headerEndElement = props.headerEndElement;
  let count = props.count;
  let headerEndElement = __headerEndElement !== undefined ? __headerEndElement : null;
  let isDimmed = Stdlib_Option.mapOr(count, false, count => count === 0);
  return JsxRuntime.jsx(CanarySurface.make, {
    tone: "neutral-ghost",
    opacity: isDimmed ? 0.55 : 1,
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsxs(Inline.make, {
          children: [JsxRuntime.jsxs(Inline.make, {
            children: [JsxRuntime.jsx(CanaryCard.Title.make, {
              children: props.title
            }), count !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [JsxRuntime.jsx(CanarySeparator.make, {
                size: "auto",
                spacing: "s"
              }), JsxRuntime.jsx(CountBadge.make, {
                children: count.toString().padStart(count > 0 ? 2 : 1, "0"),
                size: "small",
                variation: "outline",
                tone: "neutral"
              })]
            }) : null],
            alignY: "center"
          }), headerEndElement],
          align: "spaceBetween",
          alignY: "center"
        }), props.children],
        space: "large"
      }),
      spaceX: "large",
      spaceY: "large"
    })
  });
}
let LoyaltySection = {
  make: CustomerDetailsLoyalty$Tabview$LoyaltySection
};
function CustomerDetailsLoyalty$Tabview$LoyaltyStatistics$LoyaltyStatisticTile(props) {
  let __pending = props.pending;
  let __tone = props.tone;
  let tone = __tone !== undefined ? __tone : "neutral-ghost";
  let pending = __pending !== undefined ? __pending : false;
  return JsxRuntime.jsx(CanarySurface.make, {
    tone: tone,
    grow: true,
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsx(Title.make, {
            children: props.label,
            level: 4,
            weight: "semibold",
            wrap: false
          }), pending ? JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Spinner.make, {
              size: 22
            }),
            style: {
              paddingTop: "6px",
              paddingBottom: "2.5px"
            }
          }) : JsxRuntime.jsx(Title.make, {
            children: props.value,
            level: 0,
            color: props.valueColor,
            wrap: false
          })],
          space: "normal"
        }), props.children],
        space: "xlarge"
      }),
      spaceX: "xlarge",
      spaceY: "large"
    })
  });
}
let LoyaltyStatisticTile = {
  make: CustomerDetailsLoyalty$Tabview$LoyaltyStatistics$LoyaltyStatisticTile
};
let styles$1 = {
  body: {
    "backgroundColor-kWkggS": "backgroundColor-xx95sbj",
    "borderTopColor-kLZC3w": "borderTopColor-x12ejjlf",
    "borderTopStyle-kPef9Z": "borderTopStyle-x13fuv20",
    "borderTopWidth-kEafiO": "borderTopWidth-x178xt8z",
    $$css: "wino-gc:src/modules/Customer/CustomerDetailsLoyalty.res.js:2176"
  }
};
function CustomerDetailsLoyalty$Tabview$LoyaltyStatistics(props) {
  let stats = props.stats;
  let recentGainedPoints = stats.recentGainedPoints;
  let nextExpiration = stats.nextExpiration;
  let recentActivityPending = Stdlib_Option.isNone(recentGainedPoints);
  let match = {
    className: "backgroundColor-xx95sbj borderTopColor-x12ejjlf borderTopStyle-x13fuv20 borderTopWidth-x178xt8z",
    "data-style-src": "wino-gc:src/modules/Customer/CustomerDetailsLoyalty.res.js:2176"
  };
  return JsxRuntime.jsx(CanarySurface.make, {
    tone: "neutral-ghost",
    children: JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(CanaryCard.Title.make, {
          children: I18n.t("Statistics")
        }),
        spaceX: "large",
        spaceY: "large"
      }), JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsxs(Grid.make, {
            gap: "xl",
            children: [JsxRuntime.jsx(CustomerDetailsLoyalty$Tabview$LoyaltyStatistics$LoyaltyStatisticTile, {
              tone: "brand",
              label: I18n.t("Available points"),
              value: Loyalty.formatePoints(true, stats.availablePoints),
              valueColor: "#A01E72",
              children: JsxRuntime.jsx(TextStyle.make, {
                children: I18n.t("Ready to use"),
                variation: "normal",
                size: "small",
                wrap: false
              })
            }), nextExpiration !== undefined ? JsxRuntime.jsx(CustomerDetailsLoyalty$Tabview$LoyaltyStatistics$LoyaltyStatisticTile, {
              label: I18n.t("Soon expiring"),
              value: Loyalty.formatePoints(true, -nextExpiration.points | 0),
              valueColor: "#D92964",
              children: JsxRuntime.jsxs(Inline.make, {
                children: [JsxRuntime.jsx(Icon.make, {
                  name: "status_warning",
                  fill: "#D92964",
                  width: 14,
                  height: 14
                }), JsxRuntime.jsx(TextStyle.make, {
                  children: DateHelpers.formateToNumericDate(nextExpiration.expiresAt),
                  variation: "negative",
                  size: "small",
                  wrap: false
                })],
                space: "xsmall",
                alignY: "center"
              })
            }) : null, JsxRuntime.jsx(CustomerDetailsLoyalty$Tabview$LoyaltyStatistics$LoyaltyStatisticTile, {
              label: I18n.t("Recent gains"),
              value: "+" + Loyalty.formatePoints(true, Stdlib_Option.getOr(recentGainedPoints, 0)),
              valueColor: "#009F5D",
              pending: recentActivityPending,
              children: JsxRuntime.jsx(TextStyle.make, {
                children: I18n.t("Last 3 months"),
                variation: "normal",
                size: "small",
                wrap: false
              })
            }), JsxRuntime.jsx(CustomerDetailsLoyalty$Tabview$LoyaltyStatistics$LoyaltyStatisticTile, {
              label: I18n.t("Recent spending"),
              value: Loyalty.formatePoints(true, Stdlib_Option.getOr(stats.recentSpentPoints, 0)),
              pending: recentActivityPending,
              children: JsxRuntime.jsx(TextStyle.make, {
                children: I18n.t("Last 6 months"),
                variation: "normal",
                size: "small",
                wrap: false
              })
            })]
          }),
          spaceX: "large",
          spaceY: "large"
        }),
        className: match.className,
        style: match.style
      })]
    })
  });
}
let LoyaltyStatistics = {
  LoyaltyStatisticTile: LoyaltyStatisticTile,
  styles: styles$1,
  make: CustomerDetailsLoyalty$Tabview$LoyaltyStatistics
};
function CustomerDetailsLoyalty$Tabview$LoyaltyRewardLabels(props) {
  let __titleLevel = props.titleLevel;
  let reward = props.reward;
  let titleLevel = __titleLevel !== undefined ? __titleLevel : 4;
  let tmp;
  tmp = reward.TAG === "Evolutive" ? JsxRuntime.jsx(Badge.make, {
    children: I18n.t("Evolutive"),
    size: "small",
    borderColor: "#F6ABE6",
    backgroundColor: "#FDF2FB",
    foregroundColor: "#A01E72"
  }) : null;
  let description = Loyalty.formateRewardDescription(reward);
  return JsxRuntime.jsxs(Stack.make, {
    children: [JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsx(Title.make, {
        children: Loyalty.formateRewardTitle(reward),
        level: titleLevel,
        weight: "semibold"
      }), tmp],
      space: "small",
      alignY: "center"
    }), description !== undefined ? JsxRuntime.jsx(TextStyle.make, {
      children: description,
      size: "xsmall",
      wrap: false
    }) : null],
    space: "xsmall"
  });
}
let LoyaltyRewardLabels = {
  make: CustomerDetailsLoyalty$Tabview$LoyaltyRewardLabels
};
let styles$2 = {
  illustrationContainer: {
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "height-kZKoxP": "height-xjp8j0k",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "width-kzqmXN": "width-x13oubkp",
    $$css: "wino-gc:src/modules/Customer/CustomerDetailsLoyalty.res.js:2325"
  }
};
let illustrationStyle$1 = {
  display: "block",
  height: "80%",
  width: "80%",
  objectFit: "contain"
};
function illustrationSrc(reward) {
  switch (reward.TAG) {
    case "Offered":
      return Illustration.loyaltyGiftSrc;
    case "Fixed":
    case "Evolutive":
      return Illustration.loyaltyVoucherSrc;
    case "Percent":
      return Illustration.loyaltyDiscountSrc;
  }
}
let make$1 = React.memo(props => {
  let visitsCooldown = props.visitsCooldown;
  let pointsCost = props.pointsCost;
  let reward = props.reward;
  let tmp;
  let exit = 0;
  if (pointsCost !== undefined || visitsCooldown !== undefined) {
    exit = 1;
  } else {
    tmp = null;
  }
  if (exit === 1) {
    let tmp$1;
    if (pointsCost !== undefined) {
      let separator = Stdlib_Option.isSome(visitsCooldown) ? " | " : "";
      tmp$1 = Loyalty.formateRewardPointsCost(pointsCost) + separator;
    } else {
      tmp$1 = null;
    }
    tmp = JsxRuntime.jsxs(TextStyle.make, {
      children: [tmp$1, visitsCooldown !== undefined ? JsxRuntime.jsx(TextStyle.make, {
        children: Loyalty.formateRewardVisitsCooldown(visitsCooldown),
        variation: {
          NAME: "custom",
          VAL: "#25243A"
        },
        weight: "semibold",
        size: "xxsmall",
        wrap: false
      }) : null],
      variation: {
        NAME: "custom",
        VAL: "#A01E72"
      },
      weight: "semibold",
      size: "xxsmall",
      wrap: false
    });
  }
  return JsxRuntime.jsx(CanarySurface.make, {
    tone: "neutral-ghost",
    borderColor: "#A01E72",
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsxs(Inline.make, {
        children: [JsxRuntime.jsx(CanarySurface.make, {
          tone: "brand",
          shrink: false,
          children: JsxRuntime.jsx(Box.make, {
            children: JsxRuntime.jsx("img", {
              style: illustrationStyle$1,
              alt: "",
              src: illustrationSrc(reward)
            }),
            style: Primitive_option.some(styles$2.illustrationContainer)
          })
        }), JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsx(CustomerDetailsLoyalty$Tabview$LoyaltyRewardLabels, {
            reward: reward
          }), JsxRuntime.jsxs(Stack.make, {
            children: [tmp, props.willResetPoints ? JsxRuntime.jsx(TextStyle.make, {
              children: I18n.t("Points reset on use"),
              variation: {
                NAME: "custom",
                VAL: "#767589"
              },
              size: "xxsmall"
            }) : null],
            space: "xsmall"
          })],
          space: "medium",
          align: "spaceBetween"
        })],
        space: "medium",
        alignY: "center"
      }),
      spaceX: "medium",
      spaceY: "medium"
    })
  });
});
let EligibleRewardTile = {
  styles: styles$2,
  illustrationStyle: illustrationStyle$1,
  illustrationSrc: illustrationSrc,
  make: make$1
};
function CustomerDetailsLoyalty$Tabview$LoyaltyEligibleRewardsSection(props) {
  let eligibleRewards = props.eligibleRewards;
  return JsxRuntime.jsx(CustomerDetailsLoyalty$Tabview$LoyaltySection, {
    title: I18n.t("Eligible rewards"),
    count: eligibleRewards.length,
    children: eligibleRewards.length === 0 ? null : JsxRuntime.jsx(SliderTrack.make, {
      children: chunkEligibleRewards(eligibleRewards).map((pair, index) => JsxRuntime.jsx(Stack.make, {
        children: pair.map(param => JsxRuntime.jsx(make$1, {
          reward: param.reward,
          pointsCost: param.pointsCost,
          visitsCooldown: param.visitsCooldown,
          willResetPoints: param.willResetPoints
        }, param.id)),
        space: "medium"
      }, index.toString())),
      gap: "medium",
      layout: {
        TAG: "ItemsInView",
        _0: {
          min: 1,
          base: 2,
          max: 3
        }
      },
      showSlideButtons: true
    })
  });
}
let LoyaltyEligibleRewardsSection = {
  EligibleRewardTile: EligibleRewardTile,
  make: CustomerDetailsLoyalty$Tabview$LoyaltyEligibleRewardsSection
};
let styles$3 = {
  content: {
    "boxSizing-kB7OPa": "boxSizing-x9f619",
    "height-kZKoxP": "height-x5yr21d",
    "justifyContent-kjj79g": "justifyContent-x1qughib",
    "rowGap-khm7nJ": "rowGap-x1kb72lq",
    $$css: "wino-gc:src/modules/Customer/CustomerDetailsLoyalty.res.js:2488"
  },
  iconContainer: {
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "height-kZKoxP": "height-xsdox4t",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "width-kzqmXN": "width-x1useyqa",
    $$css: "wino-gc:src/modules/Customer/CustomerDetailsLoyalty.res.js:2494"
  }
};
function iconName(reward) {
  switch (reward.TAG) {
    case "Offered":
      return "gift";
    case "Fixed":
    case "Evolutive":
      return "currency";
    case "Percent":
      return "percent";
  }
}
function iconSize(reward) {
  switch (reward.TAG) {
    case "Offered":
      return 15;
    case "Fixed":
    case "Evolutive":
    case "Percent":
      return 20;
  }
}
let make$2 = React.memo(props => {
  let visitsCount = props.visitsCount;
  let visitsToUnlock = props.visitsToUnlock;
  let pointsToUnlock = props.pointsToUnlock;
  let reward = props.reward;
  return JsxRuntime.jsx(CanarySurface.make, {
    tone: "neutral-ghost",
    grow: true,
    borderColor: "#BDBDCA",
    children: JsxRuntime.jsxs(Box.make, {
      children: [JsxRuntime.jsxs(Inline.make, {
        children: [JsxRuntime.jsx(CanarySurface.make, {
          tone: "neutral",
          shrink: false,
          children: JsxRuntime.jsx(Box.make, {
            children: JsxRuntime.jsx(Icon.make, {
              name: iconName(reward),
              fill: "#25243A",
              width: iconSize(reward),
              height: iconSize(reward),
              bold: true
            }),
            style: Primitive_option.some(styles$3.iconContainer)
          })
        }), JsxRuntime.jsx(NextBadge.make, {
          kind: "Neutral",
          label: Loyalty.formatePoints(true, pointsToUnlock),
          size: "XL",
          shape: "Pill"
        })],
        align: "spaceBetween"
      }), JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsx(CustomerDetailsLoyalty$Tabview$LoyaltyRewardLabels, {
          reward: reward,
          titleLevel: 4
        }), JsxRuntime.jsxs(Inline.make, {
          children: [JsxRuntime.jsx(CanarySurface.make, {
            tone: "neutral-ghost",
            grow: true,
            children: JsxRuntime.jsx(Box.make, {
              children: JsxRuntime.jsx(ProgressBar.make, {
                value: props.availablePoints,
                maxValue: pointsToUnlock,
                tone: "brand",
                label: I18n.t("Points"),
                capValue: true
              }),
              spaceX: "normal",
              spaceY: "normal"
            })
          }), visitsToUnlock !== undefined ? JsxRuntime.jsx(CanarySurface.make, {
            tone: "neutral-ghost",
            grow: true,
            children: JsxRuntime.jsx(Box.make, {
              children: JsxRuntime.jsx(ProgressBar.make, {
                value: Stdlib_Option.map(visitsCount, prim => prim),
                maxValue: visitsToUnlock,
                label: I18n.t("Visits"),
                capValue: true,
                pending: Stdlib_Option.isNone(visitsCount)
              }),
              spaceX: "normal",
              spaceY: "normal"
            })
          }) : null],
          space: "small",
          fullWidth: true
        })],
        space: "large"
      })],
      spaceX: "medium",
      spaceY: "medium",
      style: Primitive_option.some(styles$3.content)
    })
  });
});
let LockedRewardTile = {
  styles: styles$3,
  iconName: iconName,
  iconSize: iconSize,
  make: make$2
};
function CustomerDetailsLoyalty$Tabview$LoyaltyLockedRewardsSection(props) {
  let availablePoints = props.availablePoints;
  let lockedRewards = props.lockedRewards;
  return JsxRuntime.jsx(CustomerDetailsLoyalty$Tabview$LoyaltySection, {
    title: I18n.t("Locked rewards"),
    count: lockedRewards.length,
    children: lockedRewards.length === 0 ? null : JsxRuntime.jsx(SliderTrack.make, {
      children: lockedRewards.map(param => JsxRuntime.jsx(make$2, {
        reward: param.reward,
        availablePoints: availablePoints,
        pointsToUnlock: param.pointsToUnlock,
        visitsToUnlock: param.visitsToUnlock,
        visitsCount: param.visitsCount
      }, param.id)),
      gap: "medium",
      layout: {
        TAG: "ItemsInView",
        _0: {
          base: 2,
          max: 4
        }
      },
      showSlideButtons: true,
      stretchItems: true
    })
  });
}
let LoyaltyLockedRewardsSection = {
  LockedRewardTile: LockedRewardTile,
  make: CustomerDetailsLoyalty$Tabview$LoyaltyLockedRewardsSection
};
function CustomerDetailsLoyalty$Tabview$LoyaltyHistorySection(props) {
  let history = props.history;
  return JsxRuntime.jsx(CustomerDetailsLoyalty$Tabview$LoyaltySection, {
    title: I18n.t("Loyalty history"),
    count: history.totalCount,
    headerEndElement: history.totalCount > 5 ? JsxRuntime.jsx(CanaryCardInfoSwap.HeaderButton.make, {
      label: I18n.t("Show all"),
      icon: "see_ok",
      href: CustomerRoutes.loyaltyHistoryRoute(props.customerId)
    }) : null,
    children: history.rows.length === 0 ? null : JsxRuntime.jsx(TableView.make, {
      data: {
        TAG: "Done",
        _0: {
          TAG: "Ok",
          _0: history.rows
        }
      },
      columns: CustomerDetailsLoyaltyHistoryPage.tableColumns,
      keyExtractor: CustomerDetailsLoyaltyHistoryPage.LoyaltyHistoryTableRow.keyExtractor,
      hideCard: true,
      compactRows: true,
      compactPlaceholder: true
    })
  });
}
let LoyaltyHistorySection = {
  rowLimit: 5,
  make: CustomerDetailsLoyalty$Tabview$LoyaltyHistorySection
};
let illustrationStyle$2 = {
  display: "block",
  width: "135px"
};
function CustomerDetailsLoyalty$Tabview$LoyaltySubscribePlaceholder(props) {
  return JsxRuntime.jsx(CanarySurface.make, {
    tone: "neutral-ghost",
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsx("img", {
          style: illustrationStyle$2,
          alt: "",
          src: Illustration.loyaltySrc
        }), JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsx(Title.make, {
            children: I18n.t("Not yet subscribed!"),
            level: 2,
            align: "center",
            weight: "bold"
          }), JsxRuntime.jsx(TextStyle.make, {
            children: I18n.t("This customer is not a member of the loyalty program"),
            align: "center",
            size: "small"
          })],
          space: "xsmall",
          align: "center"
        }), JsxRuntime.jsx(Button.make, {
          label: I18n.t("Subscribe the customer to loyalty"),
          variant: "solid",
          tone: "brand",
          icon: "loyalty",
          onPress: props.onRequestSubscribe
        })],
        space: "large",
        align: "center"
      }),
      spaceX: "xlarge",
      spaceY: "xxlarge"
    })
  });
}
let LoyaltySubscribePlaceholder = {
  illustrationStyle: illustrationStyle$2,
  make: CustomerDetailsLoyalty$Tabview$LoyaltySubscribePlaceholder
};
function CustomerDetailsLoyalty$Tabview(props) {
  let customerId = props.customerId;
  let loyalty = useLoyaltyWithVisits(props.loyalty, customerId);
  let loyalty$1 = useLoyaltyWithPointsActivity(loyalty, customerId);
  if (loyalty$1 === undefined) {
    return JsxRuntime.jsx(CustomerDetailsLoyalty$Tabview$LoyaltySubscribePlaceholder, {
      onRequestSubscribe: props.onRequestSubscribe
    });
  }
  let stats = loyalty$1.stats;
  return JsxRuntime.jsxs(Stack.make, {
    children: [JsxRuntime.jsx(CustomerDetailsLoyalty$Tabview$LoyaltyStatistics, {
      stats: stats
    }), JsxRuntime.jsx(CustomerDetailsLoyalty$Tabview$LoyaltyEligibleRewardsSection, {
      eligibleRewards: loyalty$1.eligibleRewards
    }), JsxRuntime.jsx(CustomerDetailsLoyalty$Tabview$LoyaltyLockedRewardsSection, {
      lockedRewards: loyalty$1.lockedRewards,
      availablePoints: stats.availablePoints
    }), JsxRuntime.jsx(CustomerDetailsLoyalty$Tabview$LoyaltyHistorySection, {
      customerId: customerId,
      history: loyalty$1.history
    })],
    space: "large"
  });
}
let Tabview = {
  LoyaltySection: LoyaltySection,
  LoyaltyStatistics: LoyaltyStatistics,
  LoyaltyRewardLabels: LoyaltyRewardLabels,
  LoyaltyEligibleRewardsSection: LoyaltyEligibleRewardsSection,
  LoyaltyLockedRewardsSection: LoyaltyLockedRewardsSection,
  LoyaltyHistorySection: LoyaltyHistorySection,
  LoyaltySubscribePlaceholder: LoyaltySubscribePlaceholder,
  make: CustomerDetailsLoyalty$Tabview
};
let CustomerDetailsLoyaltyHistoryActivityFragment;
export { CustomerDetailsLoyaltyVoucherFragment, CustomerDetailsLoyaltyHistoryActivityFragment, CustomerDetailsLoyaltyFragment, makeReward, isVoucherActive, activeVoucherReward, compareEligibleRewards, chunkEligibleRewards, make, LoyaltyVisits, LoyaltyPointsActivity, useLoyaltyWithPointsActivity, useLoyaltyWithVisits, LoyaltyUnsubscribeModal, LoyaltyPointsEditModal, LoyaltySubscribeQuery, LoyaltySubscribeCustomerUpdateMutation, LoyaltySubscribeMutation, LoyaltySubscribeModal, LoyaltyActions, Tabview };
/* query Not a pure module */